<!-- @format -->

<div *transloco="let t">
  @if (ready) {
    <div>
      <div class="input-col" [ngClass]="{ 'invalid-selection-editor': invalid }">
        <sis-code-selection-editor
          [labelForId]="labelForId"
          [filterTranslations]="filterTranslations"
          [required]="required"
          [disabled]="disabled"
          [selectedCode]="selectedCode"
          [universityCodes]="universityCodes"
          [otherCodes]="otherCodes"
          [hideOtherCodes]="groupedCodes.hideOtherCodes"
          (onSelect)="selectCode($event)"
          [showAllLanguageVersions]="showAllLanguageVersions"
          [allowDeprecatedValueSelection]="allowDeprecatedValueSelection"
          [showLastPart]="showLastPart"
          [groupResults]="groupResults"
          [notFoundKey]="notFoundKey"
          [showNumericalCodeValue]="showNumericalCodeValue"
          [id]="id">
        </sis-code-selection-editor>
      </div>
    </div>
  }
  @if (!hasSelectionOrNotRequired()) {
    <ul class="error-list">
      <li>{{ t("SIS_COMPONENTS.SELECT.CODE_MISSING") }}</li>
    </ul>
  }
</div>
